import { type CountryCode, validatePhoneNumberLength } from 'libphonenumber-js'
import i18n from '@/i18n'

export function getPhoneValidationError(
  value: string,
  countryCode?: CountryCode
): string | null {
  const result = validatePhoneNumberLength(value, countryCode)

  if (!result) return null

  switch (result) {
    case 'NOT_A_NUMBER':
    case 'TOO_SHORT':
      return i18n.global.t('common.phoneErrors.tooShort')
    case 'INVALID_COUNTRY':
      return i18n.global.t('common.phoneErrors.invalidCountryCode')
    case 'TOO_LONG':
      return i18n.global.t('common.phoneErrors.tooLong')
    case 'INVALID_LENGTH':
      return i18n.global.t('common.phoneErrors.invalidLength')
    default:
      return i18n.global.t('common.form.invalidPhoneNumber')
  }
}
